import { render } from "./city-create.vue?vue&type=template&id=1570addc"
import script from "./city-create.vue?vue&type=script&lang=js"
export * from "./city-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__